import sliceCreator from '../../index.js';
import {EDIT_USER} from '../../../constants/index.js';
const _editUserAction = sliceCreator('EDIT_USER', EDIT_USER, 'put');

const { asyncAction: editUserAction, reducer, clearData: clearEditUserAction } = _editUserAction;

export default reducer;

export {
    editUserAction,
    clearEditUserAction
}